import select from '../dom/select';

/**
 * Custom form validation using constraint validation API.
 * https://caniuse.com/#feat=constraint-validation
 * Adds class .form-error to every input if invalid
 * Error handling is done in input atoms.
 * If all inputs are valid, submits form
 * @param {Object} event optional event
 * @param {HTMLFormElement} element Root form element
 * @returns {void}
 * @memberof Form
 */
const validateForm = (event: SubmitEvent, element?: HTMLFormElement) => {
  if (!event) return;
  event.preventDefault();

  const form = element || event.submitter?.closest('form');
  if (!form) return;

  const isValid = select('input, select, textarea', form).reduce(
    (acc: boolean, element: HTMLInputElement) => {
      const valid = element.validity.valid || element.disabled;
      const formField = element.closest(
        '.radio, .textarea, .file-upload, .input, .checkbox, .select'
      );

      if (formField) {
        if (valid) {
          formField.classList.remove('form-error');
        } else {
          formField.classList.add('form-error');
        }
      }

      return valid && acc;
    },
    true
  );

  return isValid;
};

export default validateForm;
